import { bindable, containerless } from 'aurelia-framework';

@containerless()
export class Icon {
  @bindable icon: string;

  @bindable class: string;
}
